import { XIcon } from '@phosphor-icons/react';
import { Button } from '../ui/button';

const ModalCloseButton = ({ onClick }) => (
  <Button
    variant="outline"
    size="icon"
    onClick={onClick}
    className="absolute left-1/2 -translate-x-1/2 -top-20 h-10 w-10 rounded-full q3-glass z-50 flex items-center justify-center"
    aria-label="Close"
  >
    <XIcon size="24" className="text-[var(--q3-neutral-default)]" />
  </Button>
);

export default ModalCloseButton;
